module.exports = {
  language: '中文',
  hello: '苹果'
}
